module.exports = __webpack_public_path__ + "96e73c9f29b2355fda7e629570feafc2.pdf";